import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../components/_slick-restyle.scss'

const OfferSlider = ({images, url_offer, settings, id}) => {
   return (
      <Slider {...settings}>
         {images.map((image, i) => {
            return (
               <div>
                  <div key={id + '_' + i} className='offer__slider__item'>
                     <img alt={image.alt} src={image.url} title={image.title} />
                  </div>
               </div>
            )
         })}
         <div className='offer__slider__item-link'>
            <a href={url_offer} target='_blank'>
               <span className='icon'>
                  <svg
                     fill='none'
                     height='14'
                     viewBox='0 0 8 14'
                     width='8'
                     xmlns='http://www.w3.org/2000/svg'>
                     <path
                        d='M0.758399 12.7584L6.5168 7L0.758399 1.2416'
                        stroke='#7DCEE8'
                        strokeWidth='2'
                     />
                  </svg>
               </span>
               VISIT SITE
            </a>
         </div>
      </Slider>
   )
}

export default OfferSlider
